import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../store/AuthContext.js';
import { t } from '../i18n/index.js';

interface RequireAuthProps {
  children: ReactNode;
  /** Restreint l'acces aux administrateurs. */
  adminOnly?: boolean;
}

/**
 * Garde de navigation.
 *
 * Elle ameliore l'experience (redirection immediate plutot qu'un ecran vide)
 * mais ne constitue pas une securite : chaque route protegee est verifiee cote
 * serveur, seule verification qui fasse foi.
 */
export function RequireAuth({ children, adminOnly = false }: RequireAuthProps) {
  const auth = useAuth();
  const location = useLocation();

  if (auth.initializing) {
    return <p role="status">{t().app.loading}</p>;
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/connexion" replace state={{ from: location.pathname }} />;
  }

  if (adminOnly && !auth.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
